import { useEffect, useRef, useState } from 'react';
import './TimePicker.css';

interface TimePickerProps {
    readOnly?: boolean;
    selectedTime: string;
    onTimeSelected: (selectedTime: string) => void;
}

export const timeOptions = {
    TOUTE_HEURE: "Toute heure",
    JOUR: "Jour",
    SOIR: "Soir"
};

export const times = [timeOptions.TOUTE_HEURE, timeOptions.JOUR, timeOptions.SOIR];

const TimePicker: React.FC<TimePickerProps> = ({ readOnly = false, selectedTime, onTimeSelected }) => {

    const [dropdownIsOpen, setIsOpen] = useState<boolean>(false);
    const [_selectedTime, setSelectedTime] = useState<string>(selectedTime);

    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => {
        setIsOpen(!dropdownIsOpen);
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        
            setSelectedTime(selectedTime);
   

    }, [selectedTime]);

    const isSelected = _selectedTime == timeOptions.JOUR || _selectedTime == timeOptions.SOIR;

    return <div className={["timepicker", "dropdown", isSelected ? 'selected':''].join(' ')} ref={dropdownRef}>

        <div className="dd-flex">

            <button
                type="button"
                className="selected-item"
                onClick={readOnly ? undefined : () => toggleDropdown()}
                aria-haspopup="listbox"
                aria-expanded={dropdownIsOpen}
            >
                {_selectedTime}
                {isSelected && <span className="pill-check-badge" aria-hidden="true">✓</span>}
            </button>
            {!readOnly && <button type="button" className="dropdown-btn" onClick={() => toggleDropdown()} aria-label="Choisir un moment de la journée">▼</button>}
            {dropdownIsOpen && <>
                <button
                    type="button"
                    className="dropdown-overlay"
                    aria-label="Fermer la liste des moments"
                    onClick={() => setIsOpen(false)}
                />
                <div className="dropdown-content" role="listbox" aria-label="Choisir un moment de la journée">
                    <div className="dropdown-sheet-header">Choisir un moment</div>
                    {times.map(t =>
                        <button key={t} type="button" className={["dropdown-item", t === _selectedTime ? "active" : ""].join(' ')} onClick={readOnly ? undefined : () => { setIsOpen(false); onTimeSelected(t); }}>
                            <span>{t}</span>
                            {t === _selectedTime && <span className="dropdown-item-check" aria-hidden="true">✓</span>}
                        </button>
                    )}
                </div>
            </>}
        </div>
    </div>;

}

export default TimePicker;
